import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton } from '@mui/material';
import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';
import { useThemePreference } from '../../contexts/ThemeContext';

const OppsByStatus = ({ opportunities, organizationName }) => {
    const [sortedQuotes, setSortedQuotes] = useState([])
    const [collapsed, setCollapsed] = useState(false);
    const { isDarkMode } = useThemePreference();
    const option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'center',
            textStyle: {
                color: isDarkMode ? '#d7dee7' : '#5b6b79'
            }
        },
        series: [
            {
                name: 'Quotes By Status',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: isDarkMode ? '#f8fbff' : '#1f2937'
                    }
                },
                labelLine: {
                    show: false
                },
                data: sortedQuotes
            }
        ]
    }

    useEffect(() => {
        if (opportunities.length > 0) {
            // Step 1: Initialize an empty object to keep track of counts
            const statusCounts = {};
    
            // Step 2: Iterate through the array and count occurrences of each status
            opportunities.forEach(quote => {
                if (statusCounts[quote.salesStage]) {
                    statusCounts[quote.salesStage]++;
                } else {
                    statusCounts[quote.salesStage] = 1;
                }
            });
    
            // Step 3: Convert the counts object into the desired array format
            const result = Object.keys(statusCounts).map(salesStage => ({
                value: statusCounts[salesStage],
                name: salesStage,
            }));
    
            setSortedQuotes(result)
        }
      }, [opportunities]);

    return (
        <div className="col-lg-5">
            <div className="card hive-single-customer-status-card" style={{maxHeight: "400px"}}>
                <div className="card-header d-flex align-items-center justify-content-between hive-single-customer-status-header">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <IconButton
                            className="hive-single-customer-status-toggle"
                            onClick={() => setCollapsed(!collapsed)}
                            size="small"
                            sx={{ mr: 1 }}
                        >
                            {collapsed ? <ExpandMore /> : <ExpandLess />}
                        </IconButton>

                        <h5 className="hive-single-customer-status-title" style={{ margin: 0 }}>
                        Active Opportunities By Stage - <span>{organizationName}</span>
                        </h5>
                    </Box>
                </div>
                <Collapse in={!collapsed} timeout="auto" unmountOnExit>
                    <div className="card-body hive-single-customer-status-body">
                        <ReactECharts theme="v5"
                            option={option}
                            className="hive-single-customer-status-chart"
                            style={{ height: '300px' }}
                            opts={{renderer: 'svg'}} // use svg to render the chart.
                        />
                    </div>
                </Collapse>
            </div>
        </div>
    )
}

export default OppsByStatus
